export const GET_UNITS_BY_LOCATION_ID_REQUEST = 'GET_UNITS_BY_LOCATION_ID_REQUEST';
export const GET_UNITS_BY_LOCATION_ID_SUCCESS = 'GET_UNITS_BY_LOCATION_ID_SUCCESS';
export const GET_UNITS_BY_LOCATION_ID_FAILURE = 'GET_UNITS_BY_LOCATION_ID_FAILURE';

export const REMOVE_PREVIOUS_DATA = 'REMOVE_PREVIOUS_DATA';

export const SYNC_UNIT_REQUEST = 'SYNC_UNIT_REQUEST';
export const SYNC_UNIT_SUCCESS = 'SYNC_UNIT_SUCCESS';
export const SYNC_UNIT_FAILURE = 'SYNC_UNIT_FAILURE';
